<template>
  <b-button
    :id="'btn-'+_key"
    :class="elemClass.classes"
    :disabled="disabled"
    :variant="elemStyle"
    @click="click()"
  >
    <i v-if="isIcon && iconPosition =='left'" :class="[iconClass , 'mr-gd-half my-2']"></i>
    <span class="fs-sa-14 text-nowrap">{{label}}</span>
    <i v-if="isIcon && iconPosition =='right'" :class="[iconClass , 'ml-gd-half my-2']"></i>
  </b-button>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
    }),
    // Root
    _elemClass() {
      if (typeof this.btnClass === 'string') return this.btnClass.split(" ").reduce((acc, curr)=> ({...acc, [curr]: true}), {});
      return this.btnClass;
    },
    elemClass() {
      return { 
        classes: {
          "d-flex" : true,
          "align-items-center": true,
          "justify-content-center": true,
          "btn-h-32": true,
          "cursor-not-allowed": this.disabled,
          ...this._elemClass
        },
      };
    },
    elemStyle() {
      let arrStyle = ['default','blue','dark','secondary','danger','light','outline-white']
      if (arrStyle.includes(this.btnStyle)) return this.btnStyle
      return 'blue'
    }
  },
  props: {
    _key: {
      type: String,
      default: "btn"
    },
    label:String,
    isIcon:{
      type : Boolean,
      default: false
    },
    iconClass:String,
    iconPosition:{
      type : String,
      default: 'left'
    },
    disabled:{
      type:Boolean,
      default: false
    },
    btnClass:{
      type : String,
      default: ''
    },
    btnStyle:{
      type : String,
      default: 'blue'
    },
  },
  methods: {
    click() {
      this.$emit("click");
    }
  }
}
</script>
